module.exports = __webpack_public_path__ + "media/Adventurer's First Step.87800e53.mp3";